import React from 'react';

function PaymentOverview() {
  return (
    <div>
      <p>•••• •••• •••• 1111</p>
      <p>Expires: 02 26Exp:02/26</p>
      <p><br /></p>
      <p><b>Billing Address</b></p>
      <p>Jane Doe</p>
      <p>6301 Firch Path</p>
      <p>New Albany, OH 43054</p>
      <p>USA</p>
    </div>
  );
}

export default PaymentOverview;
